// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.no-video-available[data-v-420763c6]{opacity:.7}`, "",{"version":3,"sources":["webpack://./src/components/CallView/shared/LocalVideoControlButton.vue"],"names":[],"mappings":"AACA,qCACC,UAAA","sourcesContent":["\n.no-video-available {\n\topacity: .7;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
